import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { convertDisputeSummaries } from 'functions';
import { DisputeService } from 'services';
import { currentDate, disputeApiFilter, isAuthenticated, refreshState, useSetRefreshState, useSetRefreshStateKey } from 'state';
import { DisputeSummary } from 'types';
import { userInfo } from './userInfo';

const disputeRefreshKey = 'disputeRefresh';

type DisputeSummaryParams = {
    accountId: string,
} & SerializableParam;

export const disputeSummaries = selectorFamily<DisputeSummary[], DisputeSummaryParams>({
    key: 'disputeSummaries',
    get: ({ accountId }) =>
        async ({ get }) => {
            get(currentDate);
            get(refreshState(disputeRefreshKey));
            get(refreshState(disputeSummaries({ accountId }).key));
            const { isInternalUser } = get(userInfo);

            if (get(isAuthenticated) && (isInternalUser || accountId)) {
                const service = new DisputeService();
                const apiFilter = get(disputeApiFilter(accountId));
                const data = await service.getDisputeSummariesByFilter(apiFilter);
                return convertDisputeSummaries(data);
            }
            return [];
        }
});

export const useDisputeSummaries = (accountId: string) => useRecoilValue(disputeSummaries({ accountId }));

export const useRefreshDisputeSummaries = (accountId: string) => useSetRefreshState(disputeSummaries({ accountId }));

export const useRefreshAllDisputeSummaries = () => useSetRefreshStateKey(disputeRefreshKey);
